<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="checkIn">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入住管理
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row style="float: left;">
                    <el-button :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button :disabled='disabledEdit' @click="handleEdit">编辑</el-button>
                     <el-button :disabled='disabledIn' @click="handleIn">入住</el-button>
                    <el-button :disabled='disabledRoomChange' @click="roomChange">转房</el-button>
                    <el-button :disabled='disabledSettlement' @click="settlefuc">退住结算</el-button>
                    <!-- <el-button :disabled='disabledDetail' @click="detail">详情</el-button> -->
                </el-row>
                <div style="float:right">
                    <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 5px;width:200px"></el-input>
                    <el-select
                        v-model="status"
                            style="margin:0 5px;width:200px"
                        placeholder="请选择入住状态">
                        <el-option
                            v-for="(item,i) in statusValue"
                            :key="i"
                            :label="item"
                            :value="i">
                        </el-option>
                    </el-select>

                    <el-date-picker
                        v-model="startTime"
                        type="date"
                        style="margin-left:5px;"
                        value-format="yyyy-MM-dd"
                        placeholder="实际入住开始日期" class="search">
                    </el-date-picker>
                    -
                    <el-date-picker
                        v-model="endTime"
                        type="date"
                        style="margin-right:10px;"
                        value-format="yyyy-MM-dd"
                        placeholder="实际入住结束日期" class="search">
                    </el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>


            <div>
                <template>

                    <el-table :data="tableData" :height="th" v-loading="loading" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>

                        <el-table-column prop="checkinSetmealName" label="套餐"></el-table-column>

                        <el-table-column prop="liveAddress" label="床位号"></el-table-column>

                        <el-table-column prop="price" label="单价(元/天)"></el-table-column>

                        <el-table-column prop="durationPlan" label="预住时常(天)"></el-table-column>

                        <el-table-column prop="moneyPlan" :formatter="getTofiexd" label="预计总费用(元)"></el-table-column>
                        
                        <el-table-column prop="addBalance" :formatter="getTofiexd" label="充值总金额(元)"></el-table-column>

                        <el-table-column prop="cutBalance" :formatter="getTofiexd" label="消费总金额(元)"></el-table-column>

                        <el-table-column prop="balance" :formatter="getTofiexd" label="余额(元)"></el-table-column>

                        <el-table-column prop="beginTimePlan" :formatter="formatterTime1" label="预计入住时间"></el-table-column>

                        <el-table-column prop="endTimePlan" :formatter="formatterTime1" label="预计退住时间"></el-table-column>

                        <el-table-column prop="beginTime" :formatter="formatterTime" label="实际入住时间"></el-table-column>

                        <el-table-column prop="endTime" :formatter="formatterTime" label="实际退住时间"></el-table-column>

                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="登记时间"></el-table-column>


                        <el-table-column
                                prop="type"
                                :formatter="typeTitle"
                                label="入住类型">
                        </el-table-column>


                        <el-table-column
                                prop="status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
            
            <el-dialog title='结算' :visible.sync="settleDialog" class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
                <el-form :model="settleForm" :rules="rules" ref="settleForm">
                    <el-row>
                        <el-col :span="12" class="item">
                            <el-form-item label="预估结算金额(元)" required>
                                <el-input v-model="settleForm.moneyPlan" disabled placeholder="请输入预估结算金额"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-form-item label="实际结算金额(元)" required prop="total">
                                <el-input type="number" v-model="settleForm.total" @change='getBalance' placeholder="请输入实际结算金额"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-form-item label="剩余余额(元)" required prop="refundMoney">
                                <el-input type="number" v-model="settleForm.refundMoney" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12" class="item">
                            <el-form-item label="是否退还余额" required prop="isRefund">
                                <el-radio-group v-model="settleForm.isRefund" style="width:100%">
                                    <el-radio :label="1">退款</el-radio>
                                    <el-radio :label="2">不退款</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24" class="item">
                            <el-form-item label="备注" required prop="remarks">
                                <el-input v-model="settleForm.remarks" type="textarea" placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="settleDialog=false">取 消</el-button>
                    <el-button type="primary"  @click="settleSub('settleForm')">提交</el-button>
                </div>
            </el-dialog>
        </div>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly" v-bind:setmealList="setmealList" v-bind:ListBerth="ListBerth" v-on:getList="getList"></GetElderly>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:ListBerth="ListBerth"  v-bind:setmealList="setmealList" v-on:getList="getList"></Edit>
        <Detail ref="myDetail" v-show="showModalDetail" v-on:closeDetail="closeDetail"></Detail>
        <RoomChange ref="myRoomChange" v-show="showModalRoomChange" v-on:closeRoomChange="closeRoomChange" v-bind:ListBerth="ListBerth"  v-bind:setmealList="setmealList" v-on:getList="getList"></RoomChange>

    </div>
</template>

<script>
    import Edit from "./Edit";
    import GetElderly from "./GetElderly";
    import RoomChange from "./RoomChange";
    import Detail from "./Detail";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data() {
            return {
                loading: true,
                menuButtonList:null,
                disabledAdd:true,
                disabledIn:true,
                disabledEdit:true,
                disabledSettlement:true,
                disabledRoomChange:true,
                disabledContract:true,
                disabledDetail:true,
                elderlyName:"",
                status:0,
                startTime:"",
                endTime:"",
                statusValue:['入住状态','已预约','入住中','已退住'],
                showModalAdd: false,
                showModalRoomChange: false,
                showModalZiXuanRoomChange:false,
                datetimerangeValue: '',
                showModalEdit: false,
                showModalZiXuanEdit:false,
                showModalDetail:false,
                batchDialog: false,
                settleDialog: false,
                elderlyBalance: '',
                settleForm: {
                    moneyPlan: null,
                    refundMoney: null,
                    total: null,
                    remarks: null,
                    isRefund:2,
                },
                rules:{
                    totalMoney:[
                        { required: true, message: '请输入实际结算金额', trigger: 'blur' },
                        {
                            pattern: /^(\d?)+(\.\d{0,2})?$/,
                            message: '小数点后数字不能超过两位', trigger: 'blur'
                        },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                    isRefund:[
                        { required: true, message: '请选择是否退款', trigger: 'blur' },
                    ],
                },
                showModalGetElderly: false,
                tableData: null,
                ListBerth: null,
                setmealList: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                checkInfo:''
            }
        },

        created() {
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                console.log(val);
                this.th = val;
            },
        },
        components: {
            Edit,GetElderly,RoomChange,Detail
        },
        methods: {
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinSetmeal/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.setmealList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            checkInSub(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/CheckinToElderly",
                    data:{
                        timeStr:timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:this.checkInfo.checkinCode
                    }
                }).then((response) => {
                    this.loading = false;
                    if (response.data.error == 0) {
                        this.batchDialog=false
                        this.getList()
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getTofiexd(row, column, cellValue){
                var data=cellValue
                var list=cellValue.toString().split(".")
                if(list.length==2){
                    if(list[1].length>2){
                        data=cellValue.toFixed(2)
                    }
                }
                return data
            },
            getBalance(){
                this.settleForm.refundMoney=this.elderlyBalance-this.settleForm.total
                if(this.settleForm.refundMoney<0){
                    this.$alert('账户余额不足，请充值后结算', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            console.log(action)
                            this.settleDialog=false
                        }
                    });
                }
            },
            settlefuc(){
                
                var checkinCode=this.checkInfo.checkinCode
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/SettleMoney",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinCode:checkinCode,
                    }
                }).then((response) => {
                    if (response.data.error == 0) {
                        this.settleForm.moneyPlan = response.data.data.moneyPlan;
                        this.settleForm.total=response.data.data.moneyPlan;
                        this.elderlyBalance=response.data.data.elderly.balance;
                        this.settleForm.refundMoney=this.elderlyBalance-this.settleForm.total
                        if(this.settleForm.refundMoney<0){
                            this.$message.warning('账户余额不足，请充值后结算')
                        }else{
                            this.settleDialog=true
                            this.$refs.settleForm.resetFields();
                        }
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            roomChange(){
                if(this.checkInfo.chargeType!=2){
                    this.$refs.myRoomChange.init(this.checkInfo);
                    this.showModalRoomChange = !this.showModalRoomChange;
                }
                if(this.checkInfo.chargeType==2){
                    this.$refs.myZiXuanRoomChange.init(this.checkInfo);
                    this.showModalZiXuanRoomChange = !this.showModalZiXuanRoomChange;
                }
                
            },
            uploadContract(){

            },
            settleSub(settleForm){
                this.$refs[settleForm].validate((valid) => {
                    if(valid){
                        var checkinCode=this.checkInfo.checkinCode
                        var refundMoney=this.settleForm.refundMoney
                        if(this.settleForm.isRefund==2){
                            refundMoney=0
                        }
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl + "Checkin/RetreatSettle",
                            data: {
                                timeStr: timeStr,
                                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                                staffCode: getStaffCode(),
                                checkinCode:checkinCode,
                                remarks:this.settleForm.remarks,
                                total:this.settleForm.total,
                                isRefund:this.settleForm.isRefund,
                                refundMoney:refundMoney,
                            }
                        }).then((response) => {
                            console.log(response);
                            if (response.data.error == 0) {
                                this.settleDialog=false
                                this.$refs.settleForm.resetFields();
                                this.getList()
                            } else if (response.data.error == 1) {
                                this.$message({type: 'info', message: response.data.message});
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
                
            },
            getList() {
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "Checkin/Page",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        status:this.status-1,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                    }
                }).then((response) => {
                    console.log(response);
                        this.loading = false;
                        this.disabledEdit=true;
                        this.disabledIn=true;
                        this.disabledSettlement=true;
                        this.disabledRoomChange=true;
                        this.disabledDetail = true;
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit() {
                console.log(this.checkInfo.chargeType);
                if(this.checkInfo.chargeType!=2){
                    this.$refs.myEdit.init(this.checkInfo);
                    this.showModalEdit = !this.showModalEdit;
                }
                if(this.checkInfo.chargeType ==2){
                    this.$refs.myZiXuanEdit.init(this.checkInfo);
                    this.showModalZiXuanEdit = !this.showModalZiXuanEdit;
                }
            },
            detail() {
                this.$refs.myDetail.init(this.checkInfo);
                this.showModalDetail = !this.showModalDetail;
            },
            //入住
            handleIn() {
                if(this.checkInfo.balance<=0){
                    this.$message.error('老人余额不足，请充值！')
                    return;
                }
                this.$confirm(this.checkInfo.elderlyName+'确认入住, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.checkInSub();
                    
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            handleType(){
                console.log("转");
            },
            toggleModalAdd: function () {
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            closeGetElderly: function () {
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            closeRoomChange: function () {
                this.showModalRoomChange = !this.showModalRoomChange;
            },
            closeZiXuanRoomChange: function () {
                this.showModalZiXuanRoomChange = !this.showModalZiXuanRoomChange;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeDetail: function () {
                this.showModalDetail = !this.showModalDetail;
            },
            closeZiXuanEdit: function () {
                this.showModalZiXuanEdit = !this.showModalZiXuanEdit;
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,10):null
            },
            statusTitle(row) {
                if (row.status == 0) {
                    return "已预约";
                }
                if (row.status == 1) {
                    return "入住中";
                }
                if (row.status == 2) {
                    return "已退住";
                }
                return "其它";
            },
            typeTitle(row) {
                if (row.type == 0) {
                    return "正式入住";
                }
                if (row.type == 1) {
                    return "试住";
                }
                if (row.type == 2) {
                    return "预约入住";
                }
                return "其它";
            },
            rowClick(row){
                this.disabledEdit=true
                this.disabledIn=true
                this.disabledSettlement=true
                this.disabledRoomChange=true
                this.disabledDetail=false
                this.checkInfo=row
                console.log(row);
                if(row.status==1){
                    if(this.menuButtonList.indexOf("退住结算")!=-1){
                        this.disabledSettlement =false;
                    }
                    if(this.menuButtonList.indexOf("转房")!=-1){
                        this.disabledRoomChange =false;
                    }
                }   
                if(row.status==0){
                    if(this.menuButtonList.indexOf("编辑")!=-1){
                        this.disabledEdit =false;
                    }
                    if(this.menuButtonList.indexOf("入住")!=-1){
                        this.disabledIn =false;
                    }
                }
            }

        }
    }
</script>

<style lang="scss" scoped>
    .checkIn /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
    .checkIn /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #F5F7FA;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
    }
    .item{
        padding: 0px 20px;
    }
</style>